import React, { useState, useEffect } from "react";
import { Table } from "antd";
import calendar from "../images/icons/calendar.svg";
import EmptyState from "./TWComponents/EmptyState";

export default function AccountPastFutureReservation({
  data,
  langData,
  defaultPerPage,
  setCurrentPage,
  currentType,
  setCurrentType,
  setDefaultPerPage,
  openWidgetAction,
}) {
  const columns = [
    {
      title: langData.title_confirmation_no,
      dataIndex: "confirmation_no",
      key: "confirmation_no",
      fixed: true,
      width: 120,
    },
    {
      title: langData.title_booking_date,
      dataIndex: "booking_date",
      key: "booking_date",
      width: 100,
    },
    {
      title: langData.title_arrival,
      dataIndex: "arrival_date",
      key: "arrival_date",
      width: 90,
    },
    {
      title: langData.title_departure,
      dataIndex: "departure_date",
      key: "departure_date",
      width: 90,
    },
    {
      title: langData.title_hotel_name,
      dataIndex: "hotel_name",
      key: "hotel_name",
      width: 235,
    },
    {
      title: langData.title_status,
      dataIndex: "status",
      key: "status",
      width: 175,
    },
  ];

  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dataTabel();
  }, [data]);

  const dataTabel = () => {
    let obj = [];
    if (process.env.GATSBY_ENABLE_AUTH0 !== "true") {
      if (data.data !== undefined) {
        data.data.forEach((val, index) => {
          obj[index] = {
            confirmation_no: val.confirmation_no,
            booking_date: val.booking_date,
            arrival_date: val.arrival_date,
            departure_date: val.departure_date,
            hotel_name: val.hotel_name,
            status: val.status,
          };
        });
      }
    }
    if (process.env.GATSBY_ENABLE_AUTH0 === "true") {
      if (data.data !== undefined) {
        data.data.forEach((val, index) => {
          obj[index] = {
            confirmation_no: val.confirmationNo,
            booking_date: val.bookingDate,
            arrival_date: val.arrivalDate,
            departure_date: val.departureDate,
            hotel_name: val.hotelName,
            status: val.status,
          };
        });
      }
    }
    setResult(obj);
    setLoading(false);
  };

  const onChangePages = (page, pageSize) => {
    setCurrentPage(page);
    setDefaultPerPage(pageSize);
    setLoading(true);
  };

  const setTypeUpComing = () => {
    setCurrentType("upcoming");
    setCurrentPage(1);
    setLoading(true);
  };

  const setTypeUpHistory = () => {
    setCurrentType("history");
    setCurrentPage(1);
    setLoading(true);
  };

  const setTypeUpAll = () => {
    setCurrentType("all");
    setCurrentPage(1);
    setLoading(true);
  };

  return (
    <>
      <div
        style={{
          background: "#FFFFFF",
          boxSizing: "border-box",
        }}>
        <div
          className="text--left tw-flex tw-flex-row tw-gap-4"
          style={{ marginBottom: "16px" }}>
          <button
            onClick={setTypeUpAll}
            style={{
              padding: "8px 16px",
              borderRadius: "20px",
              fontFamily: "Gotham",
              fontStyle: "normal",
              fontSize: "14px",
              lineHeight: "19.2px",
              textAlign: "center",
              fontWeight: `${currentType === "all" ? "normal" : "325"}`,
              color: `${currentType === "all" ? "#FFFFFF" : "#747474"}`,
              background: `${currentType === "all" ? "rgba(62, 127, 165, 0.6)" : "#FFFFFF"
                }`,
              border: `${currentType === "all" ? "" : "1px solid #747474"}`,
            }}>
            {langData.button_all}
          </button>
          <button
            onClick={setTypeUpComing}
            style={{
              padding: "8px 16px",
              borderRadius: "20px",
              fontFamily: "Gotham",
              fontStyle: "normal",
              fontSize: "12px",
              lineHeight: "19.2px",
              textAlign: "center",
              fontWeight: `${currentType === "upcoming" ? "normal" : "325"}`,
              color: `${currentType === "upcoming" ? "#FFFFFF" : "#747474"}`,
              background: `${currentType === "upcoming"
                ? "rgba(62, 127, 165, 0.6)"
                : "#FFFFFF"
                }`,
              border: `${currentType === "upcoming" ? "" : "1px solid #747474"
                }`,
            }}>
            {langData.button_upcoming}
          </button>
          <button
            onClick={setTypeUpHistory}
            style={{
              padding: "8px 16px",
              borderRadius: "20px",
              fontFamily: "Gotham",
              fontStyle: "normal",
              fontSize: "14px",
              lineHeight: "19.2px",
              textAlign: "center",
              fontWeight: `${currentType === "history" ? "normal" : "325"}`,
              color: `${currentType === "history" ? "#FFFFFF" : "#747474"}`,
              background: `${currentType === "history"
                ? "rgba(62, 127, 165, 0.6)"
                : "#FFFFFF"
                }`,
              border: `${currentType === "history" ? "" : "1px solid #747474"}`,
            }}>
            {langData.button_history}
          </button>
        </div>
        {result.length === 0 ? (
          <EmptyState
            icon={calendar}
            description={langData.reservation_emptynote}
            buttonTitle={langData.explore_hotel}
            openWidgetAction={openWidgetAction}
            tab="reservation"
          />
        ) : (
          <Table
            size="small"
            scroll={{ x: 760 }}
            columns={columns}
            loading={loading}
            dataSource={result}
            bordered={true}
            pagination={{
              position: ["none", "bottomCenter"],
              hideOnSinglePage: true,
              responsive: true,
              defaultCurrent:
                process.env.GATSBY_ENABLE_AUTH0 === "true"
                  ? data.pagination?.currentPage
                  : data.page?.current_page,
              current:
                process.env.GATSBY_ENABLE_AUTH0 === "true"
                  ? data.pagination?.currentPage
                  : data.page?.current_page,
              defaultPageSize: defaultPerPage,
              onChange: onChangePages,
              total:
                process.env.GATSBY_ENABLE_AUTH0 === "true"
                  ? data.pagination?.total
                  : data.page?.total,
            }}
          />
        )}
        {result.length !== 0 && (
          <div
            style={{
              margin: "10px 0px",
              fontFamily: "opensans",
              fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "12px",
              lineHeight: "14px",
              textAlign: "left",
              letterSpacing: "0.8px",
              color: "#7C7C7C",
            }}>
            {langData.reservation_footnote}
          </div>
        )}
      </div>
    </>
  );
}
